import React from 'react';

import { SectionKey } from './constants';
import type { IntakeFormData } from './form/types';
import IncidentInfoSection from './sections/IncidentInfoSection';
import InsuranceSection from './sections/InsuranceSection';
import LegalLifestyleSection from './sections/LegalLifestyleSection';
import MedicalSection from './sections/MedicalSection';
import PersonalInfoSection from './sections/PersonalInfoSection';

interface Props {
  section: SectionKey;
  form: any;
  intakeId: string;
  onFieldChange: (section: any, field: string, value: any) => void;
  onCompanionsChange?: (companions: IntakeFormData['companions']) => void;
  companionRoot?: string | null;
  isCompanionPrimary?: boolean;
}

export const IntakeSection: React.FC<Props> = ({
  section,
  form,
  intakeId,
  onFieldChange,
  onCompanionsChange,
  companionRoot,
  isCompanionPrimary,
}) => {
  switch (section) {
    case 'personalInfo':
      return <PersonalInfoSection form={form} onFieldChange={onFieldChange} />;
    case 'incidentInfo':
      return (
        <IncidentInfoSection
          form={form}
          intakeId={intakeId}
          onFieldChange={onFieldChange}
          onCompanionsChange={onCompanionsChange}
          companionRoot={companionRoot}
          isCompanionPrimary={isCompanionPrimary}
        />
      );
    case 'medicalWageHistory':
      return <MedicalSection form={form} onFieldChange={onFieldChange} />;
    case 'insurance':
      return <InsuranceSection form={form} onFieldChange={onFieldChange} />;
    case 'legalLifestyle':
      return (
        <LegalLifestyleSection form={form} onFieldChange={onFieldChange} />
      );
    default:
      return null;
  }
};
